import React from 'react'
import PreferenceContainer from 'modules/preferences/PreferenceContainer.js'
import PreferenceView from 'modules/preferences/PreferenceView.js'

const PreferencePage = () => {
	return <PreferenceContainer>{PreferenceView}</PreferenceContainer>
}

export default PreferencePage
